import AbstractTab from "../AbstractTab";
import SpeciesRow from "../SpeciesRow";
import { searchPlants } from "../../../lib/plant_search";

export default class SearchTab extends AbstractTab {
    searchBar;
    rowContainer;
    pagination;
    name = 'search';
    tooltip = 'Add a plant (S)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#add-circle-line"></use></svg>';
    focused = false;

    constructor(provider, tabContainer) {
        super(provider);

        this.rows = [];

        this.searchBar = this.p.createDiv()
            .parent(tabContainer)
            .class("planner-aside-wrapper");
        this.positionSearchBar();

        let inputGroup = this.p.createDiv().parent(this.searchBar)
            .class("input-group");
        let searchLabel = this.p.createElement('h3', 'Search to add a plant').parent(inputGroup)
            .class('mar-t-0');
        this.searchInput = this.p.createInput('').parent(inputGroup)
            .class("input-text")
            .attribute("placeholder", "'Enter' to search...")
            .attribute("autocomplete", "off")
            .id('search-input');
        this.searchInput.elt.oninput = () => this.performSearch();
        this.searchInput.elt.onfocus = () => {
            this.enableHotKeys = false;
            this.focused = true;
        };
        this.searchInput.elt.onblur = () => {
            this.enableHotKeys = true;
            this.focused = false;
        };

        this.searchBar.hide();
    }

    positionSearchBar() {
        // this.searchBar.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        this.positionSearchBar();
    }

    activate() {
        // this.button.addClass('-is-active');
        this.searchBar.show();
    }

    deactivate() {
        this.searchBar.hide();
        // this.button.removeClass('-is-active');
    }

    performSearch(offset = 0) {
        let hitsPerPage = this.p.floor((this.p.height - 120) / (this.p.width > 1260 ? 64 : 60));
        searchPlants({
            q: this.searchInput.value(),
            limit: hitsPerPage,
            offset: offset,
        }).then((result) => {
            if (result?.hits) {
                this.buildResult(result);
            }
        }).catch((error) => console.warn('Plant search failed', error));
    }

    buildResult(searchResult) {
        this.rowContainer?.remove();
        this.pagination?.remove();
        let number = searchResult.offset + searchResult.limit
        this.rowContainer = this.p.createDiv()
            .parent(this.searchBar);
        this.rows = searchResult.hits.map((result) => new SpeciesRow(this.provider, result, this.rowContainer).without(['remove']));
        this.pagination = this.p.createDiv().parent(this.searchBar)
            .style('display', 'flex')
            .style('flex-direction', 'row')
            .style('align-items', 'center')
            .style('justify-content', 'space-between');
        if (searchResult.offset > 0) {
            let PrevButton = this.p.createButton('')
                .parent(this.pagination)
                .class('btn-icon-clear')
                .html('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#arrow-left-line"></use></svg>')
                .mousePressed(() => this.performSearch(searchResult.offset - searchResult.limit));
        } else {
            this.p.createDiv('')
                .parent(this.pagination)
                .style('width', '36px');
        }
        let resultLabel = this.p.createDiv(`${searchResult.offset} - ${this.p.min(number, searchResult.estimatedTotalHits)} of ${searchResult.estimatedTotalHits}`)
            .parent(this.pagination)
            .style('display', 'inline-block');
        if (number < searchResult.estimatedTotalHits) {
            let NextButton = this.p.createButton('')
                .parent(this.pagination)
                .class('btn-icon-clear')
                .html('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#arrow-right-line"></use></svg>')
                .style('float', 'right')
                .mousePressed(() => this.performSearch(number));
        } else {
            this.p.createDiv('')
                .parent(this.pagination)
                .style('width', '36px');
        }
    }
}
